import { ArrowRightIcon } from 'lucide-react'
import { useCallback, useState } from 'react'

import { type Step } from 'components/member_onboarding_v2/types'
import { TextButton } from 'slab'

import { InNetworkVerificationProgressBadge } from '../ProviderInNetworkVerification'
import { useProviderInNetworkVerificationContext } from '../ProviderInNetworkVerificationContext/ProviderInNetworkVerificationContext'
import { ProviderInNetworkVerificationProgressModal } from '../ProviderInNetworkVerificationProgressModal/ProviderInNetworkVerificationProgressModal'

export const ProviderInNetworkVerificationProgressCard: React.FC<{
  navigateToSpecificStep?: (step: Step) => void;
}> = ({ navigateToSpecificStep }) => {
  const [openInProgressModal, setOpenInProgressModal] = useState(false)
  const {
    verifyingInNetworkStatusPlanIds,
    inNetworkVerificationProgressStatus,
    error
  } = useProviderInNetworkVerificationContext()

  const seeResults = useCallback(() => {
    if (inNetworkVerificationProgressStatus === 'done') {
      if (verifyingInNetworkStatusPlanIds.length === 1) {
        navigateToSpecificStep?.(`medical_plan_details:${verifyingInNetworkStatusPlanIds[0]}?open_in_network_verification=true`)
      } else {
        navigateToSpecificStep?.(`medical_plan_comparison:${verifyingInNetworkStatusPlanIds.join(',')}`)
      }
    }
    if (inNetworkVerificationProgressStatus === 'in_progress') {
      setOpenInProgressModal(true)
    }
  }, [inNetworkVerificationProgressStatus, verifyingInNetworkStatusPlanIds])

  if (inNetworkVerificationProgressStatus === 'not_started' || error) return null

  return (
    <>
      <ProviderInNetworkVerificationProgressModal
        open={openInProgressModal}
        onOpenChange={setOpenInProgressModal}
      />
      <div className='flex flex-col gap-3 p-4 border border-gray-200 rounded-2xl items-start'>
        <div>
          <InNetworkVerificationProgressBadge inNetworkVerificationProgressStatus={inNetworkVerificationProgressStatus} />
        </div>
        <span className='body-sm text-gray-800'>
          {
            inNetworkVerificationProgressStatus === 'done'
              ? "We called your providers and asked if they are in-network with the plans that you're considering."
              : "We're actively calling your providers and asking if they are in-network with the plans that you're considering."
          }
        </span>
        <TextButton rightIcon={ArrowRightIcon} onClick={seeResults}>
          <span className='body-sm'>
            {
              inNetworkVerificationProgressStatus === 'done'
                ? 'See results'
                : 'View details'
            }
          </span>
        </TextButton>
      </div>
    </>
  )
}
